// Shared so other recording hooks can query in-flight state via
// `queryClient.isMutating` without importing the whole start/stop hooks.
// UNCARVED DOMAIN KEY (app-shell, APP-8723): desktop recording start/stop
// mutation identities live in the uncarved src/hooks/mutation hub; there is
// no /contracts door for TanStack mutationKey heads until capture/recording
// hooks carve out of the hub (STOP was grandfathered at lock; START is new).
export const START_TAURI_RECORDING_MUTATION_KEY = 'startTauriRecording';
export const STOP_RECORDING_MUTATION_KEY = 'stopRecording';
